module.exports = __webpack_public_path__ + "static/media/greentown_featured.f75ca791.jpg";